import React, { useEffect, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const testimonials = [{
  id: 1,
  quote: "It's like having an executive coach reading the room for you 24/7.",
  name: 'Sarah',
  title: 'Product Lead, SaaS',
  avatar: <svg viewBox="0 0 72 72" fill="none" data-id="element-312">
        <circle cx="36" cy="36" r="35" fill="white" stroke="#E9E7FD" strokeWidth="2" data-id="element-313" />
        <g transform="translate(12, 12)" data-id="element-314">
          <circle cx="24" cy="24" r="23" stroke="white" strokeWidth="2" data-id="element-315" />
          <path d="M10 48V35C10 28.9249 14.9249 24 21 24H27C33.0751 24 38 28.9249 38 35V48" fill="#14B8A6" data-id="element-316" />
          <circle cx="24" cy="16" r="10" fill="#8679DF" data-id="element-317" />
        </g>
      </svg>
}, {
  id: 2,
  quote: 'Contextuality alerted us that burnout was creeping into Customer Support weeks before we felt it on the floor.',
  name: 'Michael',
  title: 'CTO, FinTech',
  avatar: <svg viewBox="0 0 72 72" fill="none" data-id="element-318">
        <circle cx="36" cy="36" r="35" fill="white" stroke="#E9E7FD" strokeWidth="2" data-id="element-319" />
        <g transform="translate(12, 12)" data-id="element-320">
          <rect x="1" y="1" width="46" height="46" rx="23" stroke="white" strokeWidth="2" data-id="element-321" />
          <path d="M10 48V35C10 28.9249 14.9249 24 21 24H27C33.0751 24 38 28.9249 38 35V48" fill="#8679DF" data-id="element-322" />
          <rect x="14" y="6" width="20" height="20" rx="4" fill="#14B8A6" data-id="element-323" />
        </g>
      </svg>
}, {
  id: 3,
  quote: 'Our sprint velocity jumped 18% once we could finally see engagement dip in real time.',
  name: 'Aisha',
  title: 'Engineering Manager, HealthTech',
  avatar: <svg viewBox="0 0 72 72" fill="none" data-id="element-324">
        <circle cx="36" cy="36" r="35" fill="white" stroke="#E9E7FD" strokeWidth="2" data-id="element-325" />
        <g transform="translate(12, 12)" data-id="element-326">
          <path d="M1 24C1 11.2975 11.2975 1 24 1C36.7025 1 47 11.2975 47 24V47H1V24Z" stroke="white" strokeWidth="2" data-id="element-327" />
          <path d="M10 48V35C10 28.9249 14.9249 24 21 24H27C33.0751 24 38 28.9249 38 35V48" fill="#14B8A6" data-id="element-328" />
          <path d="M24 6L32 20H16L24 6Z" fill="#8679DF" data-id="element-329" />
          <rect x="22" y="18" width="4" height="4" fill="#14B8A6" data-id="element-330" />
        </g>
      </svg>
}];
export const TestimonialsSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [floating, setFloating] = useState(true);
  const nextSlide = () => {
    if (animating) return;
    setAnimating(true);
    setFloating(false);
    setTimeout(() => {
      setActiveIndex(current => current === testimonials.length - 1 ? 0 : current + 1);
      setAnimating(false);
      setTimeout(() => setFloating(true), 100);
    }, 300);
  };
  const prevSlide = () => {
    if (animating) return;
    setAnimating(true);
    setFloating(false);
    setTimeout(() => {
      setActiveIndex(current => current === 0 ? testimonials.length - 1 : current - 1);
      setAnimating(false);
      setTimeout(() => setFloating(true), 100);
    }, 300);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return <section className="py-20 bg-[#F5F8FF]" data-id="element-331">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-332">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-333">
          What Our Customers Say
        </h2>
        <div className="relative max-w-4xl mx-auto" data-id="element-334">
          <div className="relative h-[300px] md:h-[250px]" data-id="element-335">
            {testimonials.map((testimonial, index) => <div key={testimonial.id} className={`absolute w-full transition-all duration-500 ${index === activeIndex ? 'opacity-100 translate-x-0' : index < activeIndex ? 'opacity-0 -translate-x-12' : 'opacity-0 translate-x-12'}`} style={{
            display: index === activeIndex ? 'block' : 'none'
          }} data-id="element-336">
                <div className="bg-white rounded-xl shadow-lg p-8 text-center" data-id="element-337">
                  <div className="mb-6" data-id="element-338">
                    <div className="w-[72px] h-[72px] mx-auto mb-4 transition-transform duration-3000" data-id="element-339">
                      {testimonial.avatar}
                    </div>
                    <h3 className="font-semibold text-gray-900" data-id="element-340">
                      {testimonial.name}
                    </h3>
                    <p className="text-sm text-gray-600" data-id="element-341">{testimonial.title}</p>
                  </div>
                  <p className="text-xl italic text-gray-800" data-id="element-342">
                    "{testimonial.quote}"
                  </p>
                </div>
              </div>)}
          </div>
          <div className="flex justify-center mt-8 space-x-4" data-id="element-343">
            <button onClick={prevSlide} className="p-2 rounded-full border border-gray-300 text-gray-600 hover:bg-white transition-colors" aria-label="Previous testimonial" data-id="element-344">
              <ChevronLeftIcon size={20} data-id="element-345" />
            </button>
            <div className="flex items-center space-x-2" data-id="element-346">
              {testimonials.map((_, index) => <button key={index} className={`w-2 h-2 rounded-full transition-all ${index === activeIndex ? 'bg-[#8679DF] w-6' : 'bg-gray-300'}`} onClick={() => {
              setFloating(false);
              setActiveIndex(index);
              setTimeout(() => setFloating(true), 100);
            }} aria-label={`Go to testimonial ${index + 1}`} data-id="element-347" />)}
            </div>
            <button onClick={nextSlide} className="p-2 rounded-full border border-gray-300 text-gray-600 hover:bg-white transition-colors" aria-label="Next testimonial" data-id="element-348">
              <ChevronRightIcon size={20} data-id="element-349" />
            </button>
          </div>
        </div>
      </div>
    </section>;
};